import React from 'react';

/**
 * Componente de barra de progreso para subida de imágenes
 * @param {number} progress - Progreso de 0 a 100
 */
function ImageUploadProgress({ progress }) {
    return (
        <div className="px-4 py-3 border-b border-line bg-surface-2">
            <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-content">
                    Subiendo imágenes...
                </span>
                <span className="text-sm font-medium text-content">
                    {Math.round(progress)}%
                </span>
            </div>
            <div className="w-full bg-line rounded-full h-2.5">
                <div
                    className="h-2.5 rounded-full bg-amber transition-all duration-300 ease-out"
                    style={{
                        width: `${progress}%`
                    }}
                />
            </div>
        </div>
    );
}

export default ImageUploadProgress;
